import { useLocation } from '@remix-run/react'
import { useEffect } from 'react'
import { useEmbed } from '~/hooks'
import Container from './Container'
export { ErrorBoundary } from '~/components'

export default function MapLayout() {
  const { isEmbed, updateHostPageURL } = useEmbed()
  const location = useLocation()

  useEffect(() => {
    if (isEmbed && location.pathname === '/') {
      updateHostPageURL()
    }
  }, [isEmbed, location.pathname, updateHostPageURL])

  return <Container />
}
